import React, { useState, useEffect } from 'react';
import { Edit, Trash } from "lucide-react";
import adminService from '../services/adminServices';
import '../styles/subsStyle.css';

export default function Gestion_de_subscripciones() {
  // Form state - CORREGIDO: usando periority para coincidir con el backend
  const [formData, setFormData] = useState({
    name: '',
    rate: '',
    periority: '', // CORREGIDO: usando periority como en el backend
    feature: '',
    parkingId: ''
  });

  // Data state
  const [subscriptions, setSubscriptions] = useState([]);
  const [parkings, setParkings] = useState([]);
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [filterCedula, setFilterCedula] = useState('');

  // Load data on component mount
  useEffect(() => {
    loadAllData();
  }, []);

  // Cargar todos los datos necesarios
  const loadAllData = async () => {
    setLoading(true);
    try {
      await Promise.all([
        loadSubscriptions(),
        loadParkings(),
        loadSubscribers()
      ]);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadSubscriptions = async () => {
    try {
      const response = await adminService.getAllSubscriptions();
      setSubscriptions(response || []);
    } catch (error) {
      console.error('Error loading subscriptions:', error);
      alert('Error al cargar las suscripciones: ' + (error.response?.data?.message || error.message));
    }
  };

  
  const loadParkings = async () => {
    try {
      const response = await adminService.getAdminParkings();
     
      
      // Manejar diferentes estructuras de respuesta
      let parkingsData = [];
      if (response.success && response.parkings) {
        parkingsData = response.parkings;
      } else if (Array.isArray(response)) {
        parkingsData = response;
      } else if (response.data && Array.isArray(response.data)) {
        parkingsData = response.data;
      } else if (response.success && response.data) {
        parkingsData = response.data;
      }
      
      
      setParkings(parkingsData);

      // Si no hay parqueos, intentar con getAvailableParkings
      if (parkingsData.length === 0) {
        console.log('No hay parqueos con getAdminParkings, intentando getAvailableParkings...');
        try {
          const alternativeResponse = await adminService.getAvailableParkings();
          console.log('Respuesta de getAvailableParkings:', alternativeResponse);
          if (alternativeResponse.success && alternativeResponse.parkings) {
            setParkings(alternativeResponse.parkings);
          }
        } catch (altError) {
          console.error('Error con método alternativo:', altError);
        }
      }
    } catch (error) {
      console.error('Error loading parkings:', error);
      alert('Error al cargar los parqueos: ' + (error.response?.data?.message || error.message));
    }
  };

  const loadSubscribers = async () => {
    try {
      const response = await adminService.getAllUserSubscriptions();
      setSubscribers(response.subscriptions || []);
    } catch (error) {
      console.error('Error loading subscribers:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    
    if (!formData.name || !formData.rate || !formData.periority || !formData.feature || !formData.parkingId) {
      alert('Por favor complete todos los campos requeridos');
      return;
    }

    try {
      setLoading(true);

      
      const subscriptionData = {
        name: formData.name,
        rate: parseFloat(formData.rate),
        periority: parseInt(formData.periority), 
        feature: formData.feature,
        parkingId: formData.parkingId
      };

      console.log('Datos a enviar:', subscriptionData);

      let response;
      if (editingId) {
        response = await adminService.editSub(editingId, subscriptionData);
        if (response.success) {
          alert('Suscripción actualizada exitosamente');
        }
      } else {
        response = await adminService.createSub(subscriptionData);
        if (response.success) {
          alert('Suscripción creada exitosamente');
        }
      }

      resetForm();
      await loadSubscriptions();
    } catch (error) {
      console.error('Error saving subscription:', error);
      alert('Error al guardar la suscripción: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (subscription) => {
    setFormData({
      name: subscription.name,
      rate: subscription.rate.toString(),
      periority: subscription.periority ? subscription.periority.toString() : '', 
      feature: subscription.feature,
      parkingId: subscription.parkingId || ''
    });
    setEditingId(subscription._id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Está seguro de que desea eliminar esta suscripción?')) {
      return;
    }

    try {
      setLoading(true);
      const response = await adminService.deleteSub(id);
      if (response.success) {
        alert('Suscripción eliminada exitosamente');
        await loadSubscriptions();
      }
    } catch (error) {
      console.error('Error deleting subscription:', error);
      alert('Error al eliminar la suscripción: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      rate: '',
      periority: '', 
      feature: '',
      parkingId: ''
    });
    setEditingId(null);
  };

  const filteredSubscribers = subscribers.filter(subscriber =>
    !filterCedula || (subscriber.idCard && subscriber.idCard.toString().includes(filterCedula))
  );

  const formatSubscriberData = (subscriber) => {
    let name = 'N/A';
    let email = 'N/A';
    let cedula = subscriber.idCard;

    if (typeof subscriber.idCard === 'object' && subscriber.idCard !== null) {
      name = `${subscriber.idCard.name || ''} ${subscriber.idCard.lastname || ''}`.trim();
      email = subscriber.idCard.email || 'N/A';
      cedula = subscriber.idCard.idCard || subscriber.idCard._id || 'N/A';
    } else if (subscriber.userId && typeof subscriber.userId === 'object') {
      name = `${subscriber.userId.name || ''} ${subscriber.userId.lastname || ''}`.trim();
      email = subscriber.userId.email || 'N/A';
      cedula = subscriber.userId.idCard || 'N/A';
    }

    return { name, email, cedula };
  };

  return (
    <div className="subscription-main-container">
      <h1 className="subscription-main-title">Gestión de Subscripción</h1>

      {/* Formulario de suscripciones */}
      <div className='subscription-form-section'>
        <h2 className="subscription-section-heading">
          {editingId ? 'Editar Subscripción' : 'Registrar Subscripción'}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="subscription-form-grid">
            <div className="subscription-form-group">
              <label className="subscription-form-label">Nombre Tarifa</label>
              <input
                type="text"
                name="name"
                className="subscription-form-input"
                placeholder="Mensual Empleado"
                value={formData.name}
                onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                required
              />
            </div>
            <div className="subscription-form-group">
              <label className="subscription-form-label">Características</label>
              <textarea
                rows="4"
                name="feature"
                className="subscription-form-textarea"
                placeholder="Describe las características de la suscripción"
                value={formData.feature}
                onChange={(e) => setFormData(prev => ({ ...prev, feature: e.target.value }))}
                required
              />
            </div>
            <div className="subscription-form-group">
              <label className="subscription-form-label">Tarifa</label>
              <input
                type="number"
                name="rate"
                className="subscription-form-input"
                placeholder="500"
                value={formData.rate}
                onChange={(e) => setFormData(prev => ({ ...prev, rate: e.target.value }))}
                min="0"
                step="0.01"
                required
              />
            </div>
            <div className="subscription-form-group">
              <label className="subscription-form-label">Prioridad</label>
              <input
                type="number"
                name="periority" // CORREGIDO: usando periority
                className="subscription-form-input"
                placeholder="1"
                value={formData.periority} // CORREGIDO
                onChange={(e) => setFormData(prev => ({ ...prev, periority: e.target.value }))}
                min="1"
                required
              />
            </div>
            <div className="subscription-form-group">
              <label className="subscription-form-label">Parqueo</label>
              <select
                name="parkingId"
                className="subscription-form-input"
                value={formData.parkingId}
                onChange={(e) => setFormData(prev => ({ ...prev, parkingId: e.target.value }))}
                required
              >
                <option value="">Seleccione un parqueo</option>
                {parkings.length === 0 && !loading && (
                  <option value="" disabled>No hay parqueos disponibles</option>
                )}
                {parkings.map((parking) => (
                  <option key={parking._id} value={parking._id}>
                    {/* CORREGIDO: usando parkingName que es el campo correcto del schema */}
                    {parking.parkingName || 'Parqueo sin nombre'} 
                  </option>
                ))}
              </select>
             
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
            <button
              type="submit"
              className="subscription-primary-button"
              disabled={loading}
            >
              {loading ? 'Guardando...' : (editingId ? 'Actualizar' : 'Guardar')}
            </button>
            {editingId && (
              <button
                type="button"
                className="subscription-primary-button"
                onClick={resetForm}
                style={{ backgroundColor: '#6c757d' }}
              >
                Cancelar
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Tabla de suscripciones registradas */}
      <div className='subscription-form-section'>
        <h2 className="subscription-section-heading">Subscripciones Registradas</h2>
        <div className="subscription-table-overflow">
          <table className="subscription-table">
            <thead className="subscription-table-header">
              <tr>
                <th>Nombre</th>
                <th>Tarifa</th>
                <th>Prioridad</th>
                <th>Parqueo</th>
                <th>Características</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                if (loading) {
                  return (
                    <tr>
                      <td colSpan="6" style={{ textAlign: 'center' }}>Cargando...</td>
                    </tr>
                  );
                }
                if (subscriptions.length === 0) {
                  return (
                    <tr>
                      <td colSpan="6" style={{ textAlign: 'center' }}>No hay suscripciones registradas</td>
                    </tr>
                  );
                }
                return subscriptions.map((subscription) => (
                  <tr key={subscription._id}>
                    <td>{subscription.name}</td>
                    <td>₡{subscription.rate}</td>
                    <td>{subscription.periority || 'N/A'}</td>
                    <td>
                      {parkings.find(p => p._id === subscription.parkingId)?.parkingName || 'N/A'}
                    </td>
                    <td style={{ maxWidth: '200px', wordWrap: 'break-word' }}>
                      {subscription.feature}
                    </td>
                    <td>
                      <button
                        onClick={() => handleEdit(subscription)}
                        style={{ marginRight: '5px', padding: '4px 8px', cursor: 'pointer' }}
                        disabled={loading}
                      >
                        <Edit size={16} />
                      </button>
                      <button
                        onClick={() => handleDelete(subscription._id)}
                        style={{ color: 'red', padding: '4px 8px', cursor: 'pointer' }}
                        disabled={loading}
                      >
                        <Trash size={16} />
                      </button>
                    </td>
                  </tr>
                ));
              })()}
            </tbody>
          </table>
        </div>
      </div>

      {/* Tabla de suscriptores */}
      <div className='subscription-form-section'>
        <h2 className="subscription-section-heading">Usuarios Suscritos</h2>
        <div style={{ marginBottom: '16px', display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input
            type="text"
            placeholder="Filtrar por cédula..."
            value={filterCedula}
            onChange={(e) => setFilterCedula(e.target.value)}
            className="subscription-form-input"
            style={{ width: '300px' }}
          />
          <button
            onClick={loadSubscribers}
            className="subscription-primary-button"
            disabled={loading}
            style={{ padding: '8px 16px' }}
          >
            {loading ? 'Actualizando...' : 'Actualizar'}
          </button>
        </div>
        <div className="subscription-table-overflow">
          <table className="subscription-table">
            <thead>
              <tr>
                <th>Cédula</th>
                <th>Nombre</th>
                <th>Email</th>
                <th>Fecha Compra</th>
                <th>Fecha Expiración</th>
                <th>Tipo Suscripción</th>
                <th>Monto</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                if (filteredSubscribers.length === 0) {
                  return (
                    <tr>
                      <td colSpan="8" style={{ textAlign: 'center' }}>
                        {loading ? 'Cargando...' : 'No hay usuarios suscritos'}
                      </td>
                    </tr>
                  );
                }
                return filteredSubscribers.map((subscriber) => {
                  const isActive = new Date(subscriber.expiration) > new Date();
                  const { name, email, cedula } = formatSubscriberData(subscriber);

                  return (
                    <tr key={subscriber._id}>
                      <td>{cedula}</td>
                      <td>{name}</td>
                      <td>{email}</td>
                      <td>{new Date(subscriber.purchaseDate).toLocaleDateString()}</td>
                      <td>{new Date(subscriber.expiration).toLocaleDateString()}</td>
                      <td>{subscriber.idSubscription?.name || 'N/A'}</td>
                      <td>₡{subscriber.amount}</td>
                      <td>
                        <span style={{
                          color: isActive ? 'green' : 'red',
                          fontWeight: 'bold'
                        }}>
                          {isActive ? 'Activa' : 'Expirada'}
                        </span>
                      </td>
                    </tr>
                  );
                });
              })()}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}